<template>
  <v-dialog
    v-model="dialogDetail"
    max-width="1200px"
    transition="dialog-transition"
    @keydown.esc="() => { if (tab == 1) close(); }"
    persistent
  >
    <v-card flat class="no__radius no__padding no__padding-scroll table-wrap__padding gui-flex-fill-rest gui-flex gui-flex-rows elevation-1" v-if="!loading">
      <v-card-title class="pa-0" :class="{'pa-3': $vuetify.breakpoint.smAndDown}">
        <v-layout row wrap align-center>
          <v-flex grow>
            <h2>Nový postupný nákup</h2>
          </v-flex>
          <v-flex shrink>
            <v-btn color="primary" fab flat @click="close" class="ma-0"><v-icon>close</v-icon></v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text class="pa-0" :class="{'pa-2': $vuetify.breakpoint.smAndDown}">
        <v-stepper v-model="tab" class="elevation-0">
          <v-stepper-header class="elevation-0">
            <v-stepper-step :complete="tab > 1" step="1" color="orange" @click="tab=1">Výběr</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="2" color="orange">Nastavení</v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1" class="pa-2">
              <v-card class="elevation-0 ma-0 pa-0 mt-0" color="transparent" v-if="newItem!=null">
                <v-layout row wrap>
                  <v-flex grow>
                    <meny-radio v-model="newItem.mena_id" @changed="(e) => { mena = e; }" class="ml-2"></meny-radio>
                  </v-flex>
                  <v-flex shrink>
                    <v-text-field
                      label="Hledat"
                      v-model="search"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-data-table
                      :headers="headers"
                      :items="items"
                      :search="search"
                      class="elevation-0"
                      :loading="loadingTable"
                    >
                      <template v-slot:items="props">
                        <td>{{ props.item.sporici_program }}</td>
                        <td>
                          <div v-for="cp in props.item.cilove_produkty">
                            <eshop-link :to="{ path: '/produkty/' + cp.id }" target="_blank">{{cp.nazev}}</eshop-link>
                          </div>
                        </td>
                        <td class="text-xs-right">{{props.item.vstupni_poplatek | formatDouble}} %</td>
                        <td class="text-xs-right">{{props.item.min_cilova_castka | formatMoneyInt}} {{props.item.mena.zkratka}}</td>
                        <td class="text-xs-right">{{props.item.min_mesicni_splatka | formatMoneyInt}} {{props.item.mena.zkratka}}</td>
                        <td><v-btn color="orange" class="white--text bold" depressed small @click="pick(props.item)">Vybrat</v-btn></td>
                      </template>
                    </v-data-table>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="2" class="pa-2">
              <v-dialog
                  v-model="dialogSale"
                  max-width="550px"
                  transition="dialog-transition"
                  v-if="dialogSale"
                  persistent
                >
                <v-card class="no__padding">
                  <v-card-title class="pa-0" :class="{'pa-3': $vuetify.breakpoint.smAndDown}">
                    <h2>Sleva na vstupní poplatek</h2>
                  </v-card-title>
                  <v-card-text class="pa-0 mt-3" :class="{'pa-2': $vuetify.breakpoint.smAndDown}">
                    <v-layout row wrap align-end>
                      <v-flex xs12>
                        <v-text-field
                          label="Zadejte slevu na vstupní poplatek"
                          suffix="Kč"
                          class="mx-2"
                          type="number"
                          v-model="sleva_vstupni_poplatek"
                          :rules="[ (e) => !e || parseFloat(e) <= max_sleva || 'Překročena maximální sleva.' ]"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions claas="pa-0 mt-3" :class="{'pa-3 mt-0': $vuetify.breakpoint.smAndDown}">
                    <v-spacer></v-spacer>
                    <v-btn color="primary elevation-0" dark @click="ulozitSlevu" v-if="parseFloat(sleva_vstupni_poplatek) <= max_sleva"><v-icon class="mr-2">save</v-icon>Uložit</v-btn>
                    <v-btn color="grey elevation-0 lighten-3" @click="dialogSale=false">Zavřít</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-card class="mb-0 elevation-0 ma-0 pa-0" color="transparent" v-if="newItem != null && newItem.sporici_produkt_id != null && newItem.mena_id != null">
                <v-card-text class="pa-0">
                  <v-form lazy-validation v-model="valid" ref="form">
                    <v-layout row wrap v-if="newItem.sporici_produkt_id != null && newItem.mena_id != null" class="mt-3">
                      <v-flex xs12>
                        <v-flex xs12 sm12>
                          <v-text-field label="Název" v-model="newItem.nazev_sporeni" class="mx-2" :rules="rulesRequired"></v-text-field>
                        </v-flex>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap class="mt-1">
                      <v-flex xs12 sm12 row>
                        <div class="mx-2">
                          <p class="mb-0">Způsob platby vstupního poplatku:</p>
                          <v-radio-group v-model="newItem.typ_vstupni_poplatek" row class="mt-1" @change="typVstupniPoplatekChanged" :rules="rulesRequired">
                            <v-radio color="orange" label="Na začátku" value="na_zacatku"></v-radio>
                            <v-radio color="orange" label="V jednotlivých splátkách" value="ve_sporeni"></v-radio>
                          </v-radio-group>
                        </div>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs12 sm4 class="pt-0">
                        <div class="mx-2">
                          <div class="caption grey--text text--darken-1">Vstupní poplatek (první platba)</div>
                          <div><span v-if="newItem.typ_vstupni_poplatek=='ve_sporeni'">1%&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>{{newItem.vstupni_poplatek_po_sleve | formatMoney}} {{newItem.mena.zkratka}}</div>
                        </div>
                      </v-flex>
                      <v-flex xs12 sm4 class="pt-0" v-if="newItem.typ_vstupni_poplatek=='ve_sporeni'">
                        <div class="mx-2">
                          <div class="caption grey--text text--darken-1">Vstupní poplatek (v jednotlivých splátkách)</div>
                          <div>{{newItem.vstupni_poplatek_procento | formatMoney}} %&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{newItem.behem_sporeni | formatMoney}} {{this.mena.zkratka}}</div>
                        </div>
                      </v-flex>
                      <v-flex xs12 sm4 :class="{ 'offset-sm4': newItem.typ_vstupni_poplatek!='ve_sporeni' }" class="text-xs-right">
                        <v-btn color="grey lighten-3 btn-tiny" small fab depressed  @click="(e) => { slevaClick(); }" v-if="max_sleva>0 && newItem.typ_vstupni_poplatek=='na_zacatku'">S</v-btn>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap class="mt-3">
                      <v-flex xs12 sm4>
                        <v-text-field label="Cílová částka" type="number" v-model="newItem.cilova_castka" class="mx-2" :suffix="newItem.mena.zkratka" :rules="rulesCilovaCastka" @input="cilovyCastkaChanged"></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm4>
                        <v-text-field label="Měsíční platba" type="number" v-model="newItem.mesicni_platba" class="mx-2" :suffix="newItem.mena.zkratka" @input="() => { newItem.prvni_platba = parseFloat(newItem.vstupni_poplatek) + parseFloat(newItem.mesicni_platba) }" :rules="rulesMesicniPlatba"></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm4>
                        <v-text-field label="První platba" v-model="newItem.prvni_platba" type="number" class="mx-2" :suffix="newItem.mena.zkratka" disabled></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap class="mt-0">
                      <v-flex xs12>
                        <sporicicilovyproduktsearch label="Vyberte cílový produkt" v-model="newItem.cilovy_produkt_id" :id="newItem.sporici_produkt_id" class="mx-2" :mena="newItem.mena_id" :rules="rulesCilovyProdukt"></sporicicilovyproduktsearch>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-card-text>
                <v-card-actions class="pt-3 pb-0">
                  <v-btn color="grey" depressed class="ma-0 white--text" @click="tab=1" v-if="!creating" outline small>
                    Zpět
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="orange" depressed class="ma-0 white--text" @click="create" :loading="creating">
                    Vytvořit postupný nákup
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card-text>
    </v-card>
    <v-card v-else>
      <v-card-text class="pa-5">
        <Loader skin="light"></Loader>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
/*import RocniBonusy from '@/pages/Klienti/RocniBonusy'
import Platby from '@/pages/Klienti/Platby'
import PredaneProdukty from '@/pages/Klienti/PredaneProdukty'*/
export default {
  data () {
    return {
      dialogDetail: true,
      loading: false,
      loadingTable: false,
      editMode: false,
      activeTab: 0,
      tabs: [ 'informace', 'platby', 'rocni_bonusy', 'graf_sporeni', 'predane_produkty' ],
      item: {},
      newItem: {},
      updating: false,
      headers: [
        { text: 'Název', value: 'sporici_program' },
        { text: 'Cílové produkty', value: 'cilove_produkty.nazev', sortable: false },
        { text: 'Vstupní poplatek', value: 'vstupni_poplatek', align: 'right' },
        { text: 'Min. cílová částka', value: 'min_cilova_castka', align: 'right' },
        { text: 'Min. měsíční splátka', value: 'min_mesicni_splatka', align: 'right' },
        { text: '', value: 'id' }
      ],
      items: [],
      tab: 1,
      dialogCreateSporeni: false,
      mena: null,
      dialogSporeniInit: {
        nazev_sporeni: null,
        cilova_castka: null,
        mesicni_platba: null,
        prvni_platba: null,
        datum_sjednani: null,
        mena: null,
        mena_id: 1,
        cilovy_produkt_id: null,
        typ_vstupni_poplatek: "na_zacatku",
        vstupni_poplatek_procento: 0,
        vstupni_poplatek: 0,
        behem_sporeni: 0,
        sporici_produkt_id: null
      },
      search: null,
      sporici_program: null,
      rulesRequired: [
        (e) => !!e || "Pole je vyžadováno"
      ],
      rulesCilovyProdukt: [
        (e) => !!e || "Cílový produkt je vyžadován."
      ],
      rulesCilovaCastka: [
        (e) => { return !isNaN(e) && parseFloat(e) >= parseFloat(this.sporici_program.min_cilova_castka) || "Min. cílová platba je: " + this.sporici_program.min_cilova_castka + " " + this.mena.zkratka; }
      ],
      rulesMesicniPlatba: [
        (e) => { return !isNaN(e) && parseFloat(e) >= parseFloat(this.sporici_program.min_mesicni_splatka) || "Min. měsíční platba je: " + this.sporici_program.min_mesicni_splatka + " " + this.mena.zkratka; }
      ],
      valid: true,
      creating: false,
      max_sleva: 0,
      dialogSale: 0,
      sleva_vstupni_poplatek: 0
    }
  },
  watch: {
    mena () {
      this.newItem.mena = this.mena;
      this.newItem.mena_id = this.mena.id;
      this.loadSporiciProgramy();
    },
    dialogDetail (v) {
      if (!v)
        this.$emit("close");
    }
  },
  props: {
    klient: String
  },
  mounted: function() {
    //this.load();
    this.newItem = window.th.copy(this.dialogSporeniInit);
    this.newItem.datum_sjednani = parseInt(new Date().getTime() / 1000);
    this.load();
  },
  methods: {
    load () {
      window.api.get("klient/nakupy/" + this.$props.klient + "/sporici-program/nastaveni").then((_body) => {
        this.max_sleva = _body.max_sleva;
      }).catch((err) => {
        console.log(err);
      });
    },
    close () {
      this.$emit('close');
    },
    loadSporiciProgramy () {
      this.loadingTable = true;
      window.api.post("sporici-produkty/search", {
        mena: this.mena.id
      }).then((_body) => {
        this.items = _body.data;
        this.loadingTable = false;
      }).catch((err) => {
        console.log(err);
        this.loadingTable = false;
      });
    },
    pick (e) {
      this.sporici_program  = e;
      this.newItem.sporici_produkt_id = e.id;
      this.newItem.typ_vstupni_poplatek = "na_zacatku";
      this.sleva_vstupni_poplatek = null;
      this.newItem.nazev_sporeni = e.sporici_program.toString();
      this.newItem.cilova_castka = e.min_cilova_castka.toString();
      this.newItem.vstupni_poplatek = parseInt(parseFloat(e.vstupni_poplatek)/100.0*e.min_cilova_castka).toString();
      this.newItem.vstupni_poplatek_po_sleve = this.newItem.vstupni_poplatek;
      this.newItem.mesicni_platba = e.min_mesicni_splatka.toString();
      this.newItem.prvni_platba = parseFloat(this.newItem.vstupni_poplatek) + parseFloat(this.newItem.mesicni_platba);
      this.newItem.vstupni_poplatek_procento = parseFloat(e.vstupni_poplatek);
      this.tab = 2;
    },
    cilovyCastkaChanged () {
      if (!isNaN(this.newItem.cilova_castka)) {
        this.typVstupniPoplatekChanged();
      }
    },
    typVstupniPoplatekChanged () {
      if (this.newItem.typ_vstupni_poplatek == 've_sporeni')  {
        this.newItem.vstupni_poplatek=parseFloat(this.newItem.cilova_castka)/100;
        this.newItem.behem_sporeni=parseFloat(this.newItem.cilova_castka) * parseFloat(this.newItem.vstupni_poplatek_procento) / 100.0;
        this.newItem.vstupni_poplatek_po_sleve = this.newItem.vstupni_poplatek;
      }
      if (this.newItem.typ_vstupni_poplatek == 'na_zacatku') {
        var sleva = this.sleva_vstupni_poplatek != null && !isNaN(this.sleva_vstupni_poplatek) ? parseFloat(this.sleva_vstupni_poplatek) : 0;
        this.newItem.vstupni_poplatek = parseInt(parseFloat(this.newItem.vstupni_poplatek_procento)/100.0*this.newItem.cilova_castka) ;
        this.newItem.vstupni_poplatek_po_sleve = this.newItem.vstupni_poplatek - sleva;
      }
      this.newItem.prvni_platba = parseFloat(this.newItem.vstupni_poplatek) + parseFloat(this.newItem.mesicni_platba);
    },
    poplatekBehemSporeni () {
      if (this.newItem.mena_id == 1)
        this.newItem.behem_sporeni = parseInt((parseFloat(this.newItem.vstupni_poplatek_procento) / 100.0 * parseFloat(this.newItem.cilova_castka)));
      else
        this.newItem.behem_sporeni = (parseFloat(this.newItem.vstupni_poplatek_procento) / 100.0 * parseFloat(this.newItem.cilova_castka)).toFixed(2);
    },
    create () {
      if (this.$refs.form.validate()) {
        this.creating = true;
        this.newItem.vstupni_poplatek_sleva = this.sleva_vstupni_poplatek;
        window.api.post("klient/nakupy/"+this.klient+"/sprorici-program", this.newItem).then((_body) => {
          this.creating = false;
          if (_body.inserted) {
            this.$emit("created");
          }
        }).catch((err) => {
          console.log(err);
          this.creating = false;
        });
      }
      else {
        var e = this.$refs.form.inputs != null && this.$refs.form.inputs.length > 0 ? this.$refs.form.inputs.filter((e) => { return e.hasError }) : [];
        if (e != null && e.length > 0) {
          e[0].$el.focus();
        }
      }
    },
    slevaClick () {
      this.dialogSale = true;
    },
    ulozitSlevu () {
      var sleva = this.sleva_vstupni_poplatek != null && !isNaN(this.sleva_vstupni_poplatek) ? parseFloat(this.sleva_vstupni_poplatek) : 0;
      this.newItem.vstupni_poplatek_po_sleve = this.newItem.vstupni_poplatek - sleva;
      this.dialogSale = false;
    }
  },
  components: {
    //RocniBonusy, Platby, PredaneProdukty
  }
}
</script>
